import { render } from "./public_backlog.vue?vue&type=template&id=7d7a1602"
import script from "./public_backlog.vue?vue&type=script&lang=js"
export * from "./public_backlog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__